import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../services/bao-service";
import "./../services/jquery-select-range";

var bindingName = "baoAutoComplete";
function _defaults() {
    this._ignoreChange = false;
    this.data = {};
    this.delay = 300;
    this.requestProperty = 'text';
    this.textProperty = 'text';
    this.idProperty = 'PrimaryKeyValue';
    this.url = 'AutoComplete/GetAutoCompleteList';
    this.max = 10;
    this.preselect = false;
    this.selectedItem = ko.observable();
    this.canceled = ko.observable(false);
    this.searched = function (result, autocompleteliste) {
    };
    this.enabled = true;
    this.searching = function () {
    };
    this.beforeSearch = function () {
    };
    this.cancelSearch = null;
    this.text = ko.observable();
    this.validate = function () {
    };
    this.itemSelected = function () {
    };
    this.itemRemoved = function () {
    };
    this.MultiSelect = ko.observable(false);
    this.Items = ko.observableArray([]);
    this.mousedown = ko.observable(false);
    this.TitleVisible = ko.observable(false);
    this.TitleText = ko.observable();
}
function _getApi(element) {
    return $(element).data(bindingName);
}
ko.bindingHandlers[bindingName] = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        _createControl(element, valueAccessor, null);
        var api = _getApi(element);
        if (allBindingsAccessor().textInput != undefined) {
            api.ViewModel.text = allBindingsAccessor().textInput;
        }
        else if (allBindingsAccessor().value != undefined) {
            api.ViewModel.text = allBindingsAccessor().value;
            ko.applyBindingsToNode(element, { textInput: api.ViewModel.text }, bindingContext);
        }
        else {
            ko.applyBindingsToNode(element, { textInput: api.ViewModel.text }, bindingContext);
        }
        _registerEvents(element, valueAccessor, viewModel);
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            api = _getApi(element);
            ko.utils.arrayForEach(api.ViewModel.subscriptions, function (s: any) {
                s.dispose();
            });
            clearTimeout(api._refTimeout);
            api.__cleaner__();
            $(element).off("blur.baoAutoComplete");
            $(element).off("keydown.baoAutoComplete");
            $(element).off("focus.baoAutoComplete");
            ko.cleanNode(api.$container[0]);
            api.$container.remove();
            $(element).removeData(bindingName);
        });
    },
    update: function (element, valueAccessor) {
        var api = _getApi(element);
        api.ViewModel.options = ko.createBindingConfig(valueAccessor(), api.ViewModel.options);
    }
};
function _selectNext(element) {
    var autoCompleteVM = _getApi(element).ViewModel;
    var array = autoCompleteVM.list();
    if (array != null && array.length > 0) {
        if (autoCompleteVM.selectedIndex() == null) {
            autoCompleteVM.selectedIndex(0);
        }
        else {
            if (autoCompleteVM.selectedIndex() < array.length - 1) {
                autoCompleteVM.selectedIndex(autoCompleteVM.selectedIndex() + 1);
            }
        }
    }
    autoCompleteVM.itemSelected(array[autoCompleteVM.selectedIndex()], true, false);
}
function _selectPrev(element) {
    var autoCompleteVM = _getApi(element).ViewModel;
    var array = autoCompleteVM.list();
    if (array != null && array.length > 0) {
        if (autoCompleteVM.selectedIndex() == null) {
            autoCompleteVM.selectedIndex(array.length - 1);
        }
        else {
            if (autoCompleteVM.selectedIndex() != 0) {
                autoCompleteVM.selectedIndex(autoCompleteVM.selectedIndex() - 1);
            }
        }
    }
    autoCompleteVM.itemSelected(array[autoCompleteVM.selectedIndex()], true, false);
}
function _cancelSearch(element) {
    var api = _getApi(element);
    if (api._searchDef != null) {
        api._searchDef.abort();
    }
    clearTimeout(api._refTimeout);
    api.ViewModel.visible(false);
}
function _evaluateInput(element, valueAccessor, e) {
    var api = _getApi(element);
    var config = api.ViewModel.options;
    api._changed = true;
    if (ko.toJS(config.enabled) == true) {
        if (config.preselect !== true) {
            config.selectedItem(null);
        }
        if (document.activeElement == element) {
            clearTimeout(api._refTimeout);
            config.beforeSearch();
            api.ViewModel.visible(false);
            api._refTimeout = setTimeout(function () {
                api = _getApi(element);
                if (($(element).val() as string).trim() != "") {
                    config = api.ViewModel.options;
                    config.searching();
                    var requestData = ko.toJS(config.data);
                    requestData[config.requestProperty] = $(element).val();
                    api._searchDef = Bao.post(config.url, JSON.stringify(requestData), function (result) {
                        api = _getApi(element);
                        config = api.ViewModel.options;
                        if (document.activeElement == element) {
                            _buildList(element, valueAccessor, result);
                            api.ViewModel.visible(result.length > 0);
                            config.searched(result, api.ViewModel.list());
                            if (config.preselect === true) {
                                if (result.length > 0 && (e == null || (e.keyCode != 8 && e.keyCode != 46))) {
                                    var length = ($(element).val() as string).length;
                                    var item = api.ViewModel.list()[0];
                                    $(element).val(item.text).change();
                                    $(element).selectRange(length, ($(element).val() as string).length);
                                    config.selectedItem(item);
                                }
                                else {
                                    config.selectedItem(null);
                                }
                            }
                            else {
                                config.selectedItem(null);
                            }
                        }
                    });
                }
            }, config.delay);
        }
        else if (($(element).val() as string).trim() == "") {
            api.ViewModel.visible(false);
            config.selectedItem(null);
            config.searched(null, []);
        }
    }
}
function _blurEvent(element, valueAccessor) {
    var api = _getApi(element);
    var config = api.ViewModel.options;
    if (config.mousedown() == false) {
        api.$container.removeClass("autocompletecontainer");
        if (api._isFocused && api._changed) {
            api.ViewModel.visible(false);
            if (config.validate != null) {
                config.validate();
            }
            api._isFocused = false;
            api._changed = false;
        }
    }
}
function _focusEvent(element) {
    var api = _getApi(element);
    api.$container.addClass("autocompletecontainer");
    api._isFocused = true;
}
function _keydownEvent(element, valueAccessor, e) {
    var api = _getApi(element);
    var config = api.ViewModel.options;
    if (e.keyCode == 9) {
        api.ViewModel.visible(false);
    }
    else if (e.keyCode == 27 || e.keyCode == 13) {
        if (e.keyCode == 13) {
            api.ViewModel.visible(false);
            _cancelSearch(element);
        }
        else if (e.keyCode == 27) {
            if (ko.unwrap(config.MultiSelect) && api.ViewModel.selectedIndex() != null) {
                api.ViewModel.visible(false);
                $(element).focus();
                api.ViewModel.selectedIndex(null);
            }
            else if (config.canceled != null) {
                config.canceled(true);
                api._changed = false;
                $(element).blur();
            }
        }
    }
    else if (e.keyCode == 40) {
        if (api.ViewModel.visible()) {
            _selectNext(element);
            Bao.Utils.stopPropagation(e);
            e.preventDefault();
        }
    }
    else if (e.keyCode == 38) {
        if (api.ViewModel.visible()) {
            _selectPrev(element);
            Bao.Utils.stopPropagation(e);
            e.preventDefault();
        }
    }
    else if (e.keyCode == 32) {
        if (ko.unwrap(config.MultiSelect) && api.ViewModel.selectedIndex() != null && api.ViewModel.visible()) {
            var selectedItem = api.ViewModel.list()[api.ViewModel.selectedIndex()];
            if (selectedItem != null) {
                api.ViewModel.toggleItem(selectedItem);
            }
            e.preventDefault();
        }
    }
}
function _registerEvents(element, valueAccessor, viewModel) {
    var api = _getApi(element);
    var config = api.ViewModel.options;
    if (config.cancelSearch != null && typeof config.cancelSearch === "string") {
        viewModel[config.cancelSearch] = _cancelSearch;
    }
    api.ViewModel.subscriptions.push(api.ViewModel.text.subscribe(function (newValue) {
        if (api.ViewModel.options._ignoreChange == false && document.activeElement == element) {
            _cancelSearch(element);
            _evaluateInput(element, valueAccessor, null);
        }
    }));
    api.ViewModel.subscriptions.push(api.ViewModel.visible.subscribe(function (newValue) {
        if (newValue == false) {
            api.ViewModel.selectedIndex(null);
        }
    }));
    $(element).on("focus.baoAutoComplete", function () {
        _focusEvent(element);
    });
    $(element).on("blur.baoAutoComplete", function () {
        _blurEvent(element, valueAccessor);
    });
    $(element).on("keydown.baoAutoComplete", function (e) {
        _keydownEvent(element, valueAccessor, e);
    });
}
function _buildList(element, valueAccessor, requestResult) {
    var api = _getApi(element);
    var config = api.ViewModel.options;
    var newItems = [];
    api.ViewModel.selectedIndex(null);
    for (var i = 0; i < requestResult.length; i++) {
        if (i < config.max) {
            var requestItem = requestResult[i];
            var newItem : any = {};
            if (typeof requestItem === 'string') {
                newItem.text = requestItem;
            }
            else {
                newItem.text = requestItem[ko.unwrap(config.textProperty)];
                newItem.data = requestItem;
            }
            newItem.selected = ko.observable(false);
            newItems.push(newItem);
            if (ko.unwrap(api.ViewModel.options.MultiSelect)) {
                ko.utils.arrayForEach(api.ViewModel.options.Items(), function (selectedItem  : any ) {
                    if (ko.unwrap(selectedItem.Key) == requestItem[ko.unwrap(config.idProperty)]) {
                        if (selectedItem.removed == undefined || selectedItem.removed() != true) {
                            newItem.selected(true);
                        }
                        newItem.SelectedItemsObject = selectedItem;
                    }
                });
            }
        }
        else {
            break;
        }
    }
    api.ViewModel.list(newItems);
    var baoSelectorApi = $(element).data("baoSelector");
    if (baoSelectorApi != null) {
        baoSelectorApi.ViewModel.visible(false);
    }
}
function _createControl(element, valueAccessor, viewModel) {
    $(element).attr("autocomplete", "off");
    var api : any = {
        ViewModel: new AutoCompleteViewModel(element),
        __cleaner__: ko.reattachHelper(element)
    };
    api.ViewModel.options = ko.createBindingConfig(valueAccessor(), new _defaults());
    api.ViewModel.text = api.ViewModel.options.text;
    var $wrapContainer = $("<div></div>");
    var $listItem = $("<li class='list-group-item' data-bind='css: {active: $index() == $root.selectedIndex()}, event: {click: function() { $root.itemSelected($data, false); }}'><span class='fal' data-bind='css: {\"fa-check-square\": selected, \"fa-square\": !selected()}, visible: $root.options.MultiSelect'></span><a data-bind='text: text'></a></li>");
    var $resultList = $("<ul data-bind='foreach: list, visible: visible'}></ul>")
        .addClass("list-group")
        .addClass("autocompletelist")
        .append($listItem);
    $resultList.on("mousedown", $.proxy(api.ViewModel.mouseDown, api.ViewModel));
    $resultList.on("mouseup", $.proxy(api.ViewModel.mouseUp, api.ViewModel));
    if (window.Hammer != undefined) {
        window.Hammer($resultList[0]).on("touch", $.proxy(api.ViewModel.mouseDown, api.ViewModel));
        window.Hammer($resultList[0]).on("release", $.proxy(api.ViewModel.mouseUp, api.ViewModel));
    }
    $(element).wrap($wrapContainer);
    var $popupcontainer = $("<div class='popupcontainer'></div>");
    $popupcontainer.append($resultList);
    $(element).after($popupcontainer);
    api.$container = $(element).parent();
    ko.applyBindings(api.ViewModel, $resultList[0]);
    $(element).data(bindingName, api);
}
function _createSelectedItem(element, item) {
    var api = _getApi(element);
    return { Key: item[ko.unwrap(api.ViewModel.options.idProperty)], Value: item[ko.unwrap(api.ViewModel.options.textProperty)], removed: ko.observable(false) };
}
function AutoCompleteViewModel(element) {
    var self = this;
    self.subscriptions = [];
    self.element = element;
    self.options = null;
    self.list = ko.observableArray();
    self.list.subscribe(function () {
    });
    self.visible = ko.observable(false);
    self.loading = ko.observable(false);
    self.selectedIndex = ko.observable();
    self.text = ko.observable();
}
AutoCompleteViewModel.prototype.itemSelected = function (item, visible, toggleItem) {
    this.options._ignoreChange = true;
    $(this.element).focus();
    if (ko.unwrap(this.options.MultiSelect) != true) {
        $(this.element).val(item.text).change();
        this.visible(visible);
        this.options.selectedItem(item);
    }
    else {
        if (toggleItem == undefined || toggleItem == true) {
            this.toggleItem(item);
        }
    }
    this.options.mousedown(false);
    this.options._ignoreChange = false;
};
AutoCompleteViewModel.prototype.toggleItem = function (item) {
    item.selected(!item.selected());
    if (item.SelectedItemsObject == null) {
        item.SelectedItemsObject = _createSelectedItem(this.element, item.data);
        this.options.Items.push(item.SelectedItemsObject);
    }
    if (item.SelectedItemsObject.removed == undefined || !ko.isObservable(item.SelectedItemsObject.removed)) {
        item.SelectedItemsObject.removed = ko.observable(false);
    }
    item.SelectedItemsObject.removed(!item.selected());
    if (item.selected()) {
        this.options.itemSelected(item);
    }
    else {
        this.options.itemRemoved(item);
    }
    this.options.Items.valueHasMutated();
};
AutoCompleteViewModel.prototype.mouseDown = function () {
    this.options.mousedown(true);
};
AutoCompleteViewModel.prototype.mouseUp = function () {
};